import { FC, PropsWithChildren } from "react";
import styles from "./OverviewGrid.module.css";

const OverviewGrid: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles["columns-container"]}>{children}</div>
);

export default OverviewGrid;
